import React, { Fragment, useEffect } from "react"
import BigNumList from "../../features/big-num-list"
import {
    FIRST_LIST,
    SECOND_LIST,
    THIRD_LIST,
    UNORDERED_LIST,
} from "../../data/privacy/lists-data"
import "./index.scss"
import { Helmet } from "react-helmet-async"

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <Helmet defer={false}>
                <title>Newsoft - Privacy policy</title>
            </Helmet>
            <div className="privacy">
                <div className="privacy-title">
                    <p className="privacy-title-main">
                        <span className="t-s1-m">At Newsoft, </span>we are
                        committed to protecting the privacy and security of your
                        <span className="t-s1-m"> personal information</span>
                    </p>
                    <p className="privacy-title-desc">
                        This Privacy Policy explains how we collect, use,
                        disclose, and protect your personal data when you visit
                        our website or use our services. By accessing or using
                        our website, you agree to the terms and conditions of
                        this Privacy Policy.
                    </p>
                </div>
                <BigNumList header="Information We Collect" list={FIRST_LIST} />
                <div className="big-num-list big-num-list-dark">
                    <h3 className="t-s3">Use of Information</h3>
                    <div className="big-num-list-block">
                        {SECOND_LIST.map((el) => (
                            <div className="big-num-list-block-item" key={el.number}>
                                <h4>{el.number}</h4>
                                <div>
                                    <h5 className="t-s3">{el.header}</h5>
                                    <p className="t-b4">{el.text}</p>
                                    <ol>
                                        {el.points.map((p, id) => (
                                            <li key={id} className="t-b4">{p}</li>
                                        ))}
                                    </ol>
                                    {el.next && <p className="t-b4">{el.next}</p>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <BigNumList
                    header="Data Sharing and Disclosure"
                    list={THIRD_LIST}
                />
                <div className="privacy-unordered-list">
                    {UNORDERED_LIST.map((el) => (
                        <Fragment key={el.header}>
                            <h4 className="t-s3">{el.header}</h4>
                            <p className="t-b4">{el.text}</p>
                        </Fragment>
                    ))}
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy
